// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Stable, StableSchema } from 'api/gen/Stable';

const requiredPart = t.interface({
  proficiencyTestDate: DateSchema,
  stables: t.union([t.array(StableSchema), t.null]),
});

export const ApcDateSchema = excess(requiredPart);

export interface ApcDate extends t.TypeOf<typeof ApcDateSchema> {}
